import * as Sentry from "@sentry/react";
import { shouldInitSentry } from "./sentryConfig";

/**
 * Logs an auth-related event to Sentry
 * @param {Object} options
 * @param {'info'|'warning'|'error'|'fatal'} options.level - Sentry log level
 * @param {string} options.message - Description of the event
 * @param {Error} [options.error] - Optional error to capture
 * @param {Object} [options.data] - Optional additional metadata
 * @param {boolean} [options.capture] - Whether to send error to Sentry (default: false i.e for info logs)
 */
export function logAuthEvent({ level = "info", message, error, data = {}, capture = false }) {
  if (!shouldInitSentry) return;

  Sentry.addBreadcrumb({
    category: "auth",
    message,
    level,
    data
  });

  if (capture && error instanceof Error) {
    Sentry.captureException(error);
  }

  if (capture && !error) {
    Sentry.captureMessage(message, level);
  }
}

/**
 * One-way, non-reversible hash for correlating auth events without sending
 * raw email addresses (or other PII) to Sentry. Use when no user id is
 * available yet (e.g. failed login, pre-auth password reset).
 */
export function hashIdentifier(value) {
  if (!value) return null;
  let hash = 0;
  const str = String(value).toLowerCase();
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return `h_${Math.abs(hash)}`;
}
